import script from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"
export * from "./RestoreAccountView.vue?vue&type=script&setup=true&lang=js"

import "./RestoreAccountView.vue?vue&type=style&index=0&id=ead54b80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ead54b80"]])

export default __exports__